<form method="post" id="checkoutForm">
    <input type="hidden" name="userId" id="userId">
    <input type="hidden" name="productId" id="productId">
    <!-- <input type="submit" id="checkOutSubmitButton"> -->
</form>